var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dispatch } from './internal';
import { isLoaded } from './Loadable/helpers';
import * as loadableUtils from './Loadable/utils';
export const actionStates = {
    START: 'START',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export const dispatchFetchSuccessAction = (res, actionName, actionData = {}, callback) => {
    if (callback) {
        callback();
    }
    dispatch({
        type: `${actionName}_${actionStates.SUCCESS}`,
        payload: Object.assign(Object.assign({}, actionData), { res: loadableUtils.createLoaded(res) }),
    });
};
export const dispatchFetchErrorAction = (err, actionName, actionData = {}, isPartial = false) => {
    dispatch({
        type: `${actionName}_${actionStates.ERROR}`,
        payload: Object.assign(Object.assign({}, actionData), { res: isPartial
                ? loadableUtils.createPartialError([], err)
                : loadableUtils.createError(err) }),
    });
};
export const fetchLoadable = (actionName_1, apiCall_1, ...args_1) => __awaiter(void 0, [actionName_1, apiCall_1, ...args_1], void 0, function* (actionName, apiCall, actionData = {}, isPartial = false, callback) {
    dispatch({
        type: `${actionName}_${actionStates.START}`,
        payload: Object.assign(Object.assign({}, actionData), { res: isPartial
                ? loadableUtils.createPartialLoading(Object.assign({}, actionData))
                : loadableUtils.createLoading() }),
    });
    try {
        const response = yield apiCall(...Object.values(actionData));
        dispatchFetchSuccessAction(response, actionName, actionData, callback);
        return response;
    }
    catch (err) {
        dispatchFetchErrorAction(err, actionName, actionData, isPartial);
        throw err;
    }
});
export const setPartialFetchStartState = (currentState, newState, listFieldName) => {
    return isLoaded(currentState)
        ? {
            loadingState: newState.loadingState,
            data: Object.assign({}, currentState.data),
        }
        : {
            loadingState: newState.loadingState,
            data: Object.assign(Object.assign({}, newState.data), { [listFieldName]: [] }),
        };
};
export const setFetchStartState = (currentState, newState) => {
    return isLoaded(currentState)
        ? loadableUtils.createReloading(currentState.data)
        : newState;
};
//# sourceMappingURL=fetchLoadable.js.map